
export const GET_UPSELL_START = 'GET_UPSELL_START';
export const GET_UPSELL_SUCCESS = 'GET_UPSELL_SUCCESS';
export const GET_UPSELL_FAILURE = 'GET_UPSELL_FAILURE';
export const GET_UPSELL_RESET = 'GET_UPSELL_RESET';




// export const GET_CITY_START = 'GET_CITY_START';
// export const GET_CITY_SUCCESS = 'GET_CITY_SUCCESS';
// export const GET_CITY_FAILURE = 'GET_CITY_FAILURE';
// export const GET_CITY_RESET = 'GET_CITY_RESET';
